import React from 'react';
import Input from '../elements/Input';

const PropertyAndAssetsForm = ({ formData, setFormData, formError }) => (
  <>
    <Input
      label="Asset Type"
      value={formData.assetType || ''}
      onChange={e => setFormData({ ...formData, assetType: e.target.value })}
      placeholder="e.g. Apartment, Car, Gold Necklace"
      error={formError.assetType}
    />
    <Input
      label="Description"
      value={formData.description || ''}
      onChange={e => setFormData({ ...formData, description: e.target.value })}
      placeholder="e.g. 2BHK in Mumbai, 2018 Honda City, 22K gold necklace"
      error={formError.description}
    />
    <Input
      label="Location"
      value={formData.location || ''}
      onChange={e => setFormData({ ...formData, location: e.target.value })}
      placeholder="e.g. Andheri, Locker #12, Home garage"
      error={formError.location}
    />
    <Input
      label="Estimated Value"
      type="number"
      value={formData.value || ''}
      onChange={e => setFormData({ ...formData, value: e.target.value })}
      placeholder="e.g. 7500000, 1200000"
      error={formError.value}
    />
    <Input
      label="Notes / Details"
      type="textarea"
      value={formData.notes || ''}
      onChange={e => setFormData({ ...formData, notes: e.target.value })}
      placeholder="Enter any additional notes or details"
      error={formError.notes}
    />
  </>
);

export default PropertyAndAssetsForm;